var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 31,
    viewBox: "0 0 20 31",
    fill: "#E0E0E0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 31V28.4799C3.37014 28.1629 0.0173611 25.33 0 21.0357H5C5.12292 22.8583 6.65694 24.2499 8.88889 24.4955V17.7143L7.02986 17.2299C2.79375 16.2487 0.527083 13.8123 0.527083 10.1663C0.527083 5.86855 3.61667 3.05018 8.88889 2.62946V0H11.1111V2.62946C16.4854 3.0654 19.375 5.9329 19.4444 9.96429H14.4444C14.3917 8.29942 13.3451 6.96185 11.1111 6.78125V13.1473L13.2514 13.6511C17.7507 14.6323 20 16.9531 20 20.7589C20 25.211 16.9625 28.0854 11.1111 28.4619V31H8.88889ZM8.88889 12.7321V6.78125C6.97292 6.88643 5.60625 8.05931 5.60625 9.72417C5.60625 11.2673 6.74444 12.2761 8.88889 12.7321ZM11.1111 18.1295V24.4955C13.7604 24.389 15.0264 23.1863 15.0264 21.3284C15.0264 19.6276 13.7604 18.4824 11.1111 18.1295Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/USD.7bcb5ee5a2a31ff49b52e517e20311f1.svg";
export { ForwardRef as ReactComponent };